import { QueryParam, StoreScoreDay } from 'types';
import { Loading, Table } from 'components';
import { routes } from 'commons';
import { RevokedReasons } from './components';
import * as S from './styles';

interface Props {
  showScore: boolean;
  tableData?: StoreScoreDay[];
  isLoading: boolean;
}

const SCORE_HEADER = 'Nível de atendimento';

export function ScoreTable({ showScore, tableData, isLoading }: Props) {
  if (isLoading) {
    return <Loading />;
  }

  const renderTableData = tableData?.map((result) => {
    const {
      confirmed,
      confirmedPercentage,
      consignments,
      date,
      revoked,
      revokedDetails,
      priority,
    } = result;

    const { deadlineExceeded, others, stockDivergence } = revokedDetails;
    const formattedDate = date.toLocaleDateString();
    const paramDate = date.getTime();

    return (
      <tr key={date.toString()}>
        <td>{formattedDate}</td>
        {showScore && <td>{priority}</td>}
        <td>{consignments}</td>
        <td>{confirmed}</td>
        <td>{revoked}</td>
        <td>{confirmedPercentage}%</td>
        <td>{deadlineExceeded}</td>
        <td>{stockDivergence}</td>
        <td>{others}</td>
        <td>
          <S.TextLinkStyle
            href={
              routes.performance.path +
              `/?${QueryParam.startDate}=${paramDate}&${QueryParam.endDate}=${paramDate}`
            }
            target="_blank"
          >
            Ver mais
          </S.TextLinkStyle>
        </td>
      </tr>
    );
  });

  const tableHeaders = [
    { name: 'Data' },
    {
      name: SCORE_HEADER,
      description: 'Performance de atendimento nessa data',
    },
    {
      name: 'Pedidos recebidos',
      description: 'Total de pedidos recebidos nessa data',
    },
    {
      name: 'Pedidos aceitos',
      description: 'Total de pedidos aceitos nessa data',
    },
    {
      name: 'Pedidos recusados',
      description: 'Total de pedidos recusados nessa data',
    },
    {
      name: 'Porcentagem de atendimento',
      description: 'Porcentagem de pedidos aceitos',
    },
    {
      name: 'Tempo excedido',
      description: 'Total de pedidos que não foram aceitos no prazo',
    },
    {
      name: 'Recusados por estoque',
      description: 'Total de pedidos recusados por falta de estoque',
    },
    {
      name: 'Recusados por outros motivos',
      description: <RevokedReasons />,
    },
    { name: 'Detalhes' },
  ];
  const filteredTableHeader = tableHeaders.filter((tableHeader) => {
    const isScoreHeader = tableHeader.name === SCORE_HEADER;

    if (isScoreHeader) return showScore;

    return true;
  });

  return (
    <Table
      headers={filteredTableHeader}
      noResults={!Boolean(tableData?.length)}
    >
      {renderTableData}
    </Table>
  );
}
